import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowSmallUpMini = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.9999 17.9999C11.7612 17.9999 11.5323 17.9051 11.3635 17.7363C11.1947 17.5675 11.0999 17.3386 11.0999 17.0999V9.13431L8.74789 11.7239C8.58059 11.8876 8.35611 11.9797 8.12207 11.9806C7.88802 11.9815 7.66282 11.8912 7.49423 11.7289C7.32564 11.5665 7.22692 11.3449 7.21902 11.111C7.21112 10.8771 7.29465 10.6493 7.45189 10.4759L11.3519 6.27591C11.4359 6.18881 11.5365 6.11952 11.6478 6.0722C11.7592 6.02488 11.8789 6.00049 11.9999 6.00049C12.1209 6.00049 12.2406 6.02488 12.3519 6.0722C12.4633 6.11952 12.5639 6.18881 12.6479 6.27591L16.5479 10.4759C16.634 10.5601 16.7023 10.6608 16.7488 10.7719C16.7953 10.883 16.819 11.0024 16.8185 11.1228C16.818 11.2432 16.7934 11.3624 16.746 11.4731C16.6987 11.5839 16.6295 11.684 16.5428 11.7675C16.456 11.8511 16.3534 11.9164 16.2409 11.9595C16.1285 12.0027 16.0085 12.0228 15.8881 12.0187C15.7677 12.0147 15.6494 11.9865 15.5401 11.9358C15.4308 11.8852 15.3328 11.8131 15.2519 11.7239L12.8999 9.13431V17.0999C12.8999 17.3386 12.8051 17.5675 12.6363 17.7363C12.4675 17.9051 12.2386 17.9999 11.9999 17.9999Z",
		fill: "currentcolor"
	})]
});
export default SvgArrowSmallUpMini;
